import React, { Component } from "react";
import { map } from "./services";
import NeshanMap from "react-neshan-map-leaflet";
import { HiCheck } from "react-icons/hi";
import { Link } from "react-router-dom";
import { isMobile } from "react-device-detect";
import { mapKey } from "../../settings/config";

class Map extends Component {
  constructor(props) {
    super(props);
    this.state = {
      latitude: this.props.coordinates
        ? this.props.coordinates.latitude
        : this.props.location &&
          this.props.location.state &&
          this.props.location.state.userLocation
        ? this.props.location.state.userLocation.latitude
        : 35.699739,
      longitude: this.props.coordinates
        ? this.props.coordinates.longitude
        : this.props.location &&
          this.props.location.state &&
          this.props.location.state.userLocation
        ? this.props.location.state.userLocation.longitude
        : 51.338097,
      key: "",
      results: null,
      showResult: false,
    };
    this.map = React.createRef();
  }
  getMap() {
    var params = {
      lat: this.state.latitude,
      lng: this.state.longitude,
      term: this.state.key,
    };
    map(params).then((items) => {
      items && this.setState({ results: items.results, showResult: true });
    });
  }
  setLocation(e) {
    this.setState({
      latitude: e.target.getCenter().lat,
      longitude: e.target.getCenter().lng,
    });
  }
  setResult(result) {
    this.setState({
      latitude: result.location.lat,
      longitude: result.location.lng,
      showResult: false,
    });
    this.map.flyTo([result.location.lng, result.location.lat], 15);
  }
  render() {
    return (
      <div>
        <div
          className="row mx-0 position-fixed"
          style={{ top: "20px", right: "30px", left: "60px", zIndex: "9" }}
        >
          <div className="col px-0">
            <input
              value={this.state.key}
              onChange={(e) =>
                this.setState({ key: e.target.value }, () => {
                  e.target.value.length > 1 && this.getMap();
                })
              }
              className="form-control rounded14 bg-white"
              style={{ height: "45px" }}
              placeholder="جستجو ..."
            />
            {this.state.results && this.state.showResult && (
              <div
                className="row mx-0 bg-white mt-3 rounded14 overflow-auto"
                style={{ height: "70vh" }}
              >
                {this.state.results.map((result, r) => (
                  <div
                    className="col-12 px-3 py-2 border-bottom"
                    onClick={() => this.setResult(result)}
                  >
                    <div className="row mx-0">
                      <div className="col-auto px-1 align-self-center">
                        <img
                          width="28"
                          src={require("./icons/pin.svg").default}
                          alt="pin-icon"
                        />
                      </div>
                      <div className="col px-1">
                        <p className="mb-0 fw-bolder">{result.title}</p>
                        <p className="mb-0 fw-bolder fs-7 text-muted">
                          {result.address}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
        <NeshanMap
          style={{
            position: "fixed",
            height: "100%",
            width: "none",
            top: "0",
            left: isMobile ? "0" : "25%",
            right: isMobile ? "0" : "25%",
            bottom: "0",
          }}
          options={{
            key: mapKey,
            center: [this.state.latitude, this.state.longitude],
            zoom: 14,
            maptype: "dreamy-gold",
            poi: true,
          }}
          onInit={(L, myMap) => {
            this.map = myMap;
            myMap.on("moveend", (e) => this.setLocation(e));
          }}
        />
        {this.props.isShopEdit ? (
          <button
            onClick={() =>
              this.props.hideMap({
                latitude: this.state.latitude,
                longitude: this.state.longitude,
              })
            }
            className="btn p-0 position-fixed rounded-circle bg-color-second row mx-0"
            style={{
              bottom: "30px",
              left: "30px",
              width: "50px",
              height: "50px",
            }}
          >
            <HiCheck
              className="text-white col align-self-center p-0"
              size="25"
            />
          </button>
        ) : (
          <Link
            to={{
              pathname: `/addresses/${
                this.props.location &&
                this.props.location.state &&
                this.props.location.state.uid &&
                this.props.location.state.uid !== "add"
                  ? this.props.location &&
                    this.props.location.state &&
                    this.props.location.state.uid
                  : "add"
              }`,
              state: {
                userLocation: {
                  longitude: this.state.longitude,
                  latitude: this.state.latitude,
                },
                fromCartOrder:
                  this.props.location &&
                  this.props.location.state &&
                  this.props.location.state.fromCartOrder,
                address:
                  this.props.location &&
                  this.props.location.state &&
                  this.props.location.state.address &&
                  this.props.location.state.address,
              },
            }}
          >
            <button
              className="btn p-0 position-fixed rounded-circle bg-color-second row mx-0"
              style={{
                bottom: "30px",
                left: "30px",
                width: "50px",
                height: "50px",
              }}
            >
              <HiCheck
                className="text-white col align-self-center p-0"
                size="25"
              />
            </button>
          </Link>
        )}
        <img
          className="position-fixed m-auto"
          width="35"
          style={{ right: "0", left: "0", bottom: "0", top: "0" }}
          src={require("./icons/pin.svg").default}
          alt="pin-icon"
        />
      </div>
    );
  }
}

export default Map;
